import { api } from './api';

function buildQuery(filters = {}) {
  const qs = new URLSearchParams();
  if (filters.q) qs.set('q', filters.q);
  if (filters.type) qs.set('type', filters.type);
  if (typeof filters.isActive === 'boolean') qs.set('isActive', filters.isActive);
  if (filters.page) qs.set('page', filters.page);
  if (filters.limit) qs.set('limit', filters.limit);
  const s = qs.toString();
  return s ? `?${s}` : '';
}

export const campaignService = {
  list: async (filters = {}) => api.get(`/api/campaigns${buildQuery(filters)}`),
  getById: async (id) => api.get(`/api/campaigns/${id}`),
  create: async (payload) => api.post('/api/campaigns', payload),
  update: async (id, payload) => api.patch(`/api/campaigns/${id}`, payload),
  remove: async (id) => api.delete(`/api/campaigns/${id}`),
  validate: async ({ code, orderSubtotal }) =>
    api.post('/api/campaigns/validate', { code, orderSubtotal })
};
